// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   Users,
//   UserCheck,
//   Clock,
//   Percent,
//   CalendarDays,
//   Landmark,
//   BarChart3,
//   Users2,
//   TrendingUp,
//   PieChart as PieChartIcon,
//   Watch,
//   CalendarX,
//   CalendarCheck2,
//   RefreshCw,
// } from "lucide-react";
// import {
//   BarChart,
//   Bar,
//   LineChart,
//   Line,
//   PieChart,
//   Pie,
//   Cell,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
// } from "recharts";

// import { getEmployeeList } from "../../action/Employee";
// import { getGradeList } from "../../action/Grade";
// import { getShiftList } from "../../action/Shift";
// import { getBankList } from "../../action/Bank";
// import { getBranchList } from "../../action/Branch";
// import { getEmployeeCategoryList } from "../../action/EmployeeCategory";

// import { mapEmployeeRow, buildLookups } from "../../utils/employeeMapper";
// import { pick, getRowName, getRowCode, toCodeMap } from "../../utils/masterDataUtils";
// import {
//   countBy,
//   calcAge,
//   buildAgeGroups,
//   buildJoiningTrend,
//   buildBranchesByBank,
//   INITIAL_LEAVE_REQUESTS,
// } from "../../utils/eHrmDashboardAnalytics";
// import { attendanceKpis, monthBounds } from "../../utils/mainDashboardAnalytics";
// import { getEmployeesAttendanceRows } from "../../store/slices/attendanceSummarySlice";

// import { StatGrid, ChartCard } from "../../components/dashboard";
// const GENDERS = [
//   { value: "M", label: "Male" },
//   { value: "F", label: "Female" },
// ];

// const PALETTE = ["#059669", "#3b82f6", "#f59e0b", "#ef4444", "#8b5cf6", "#ec4899", "#14b8a6", "#f97316"];
// const STATUS_COLORS = { Approved: "#059669", Pending: "#f59e0b", Rejected: "#ef4444" };


// const LegendRow = ({ color, label, value }) => (
//   <div className="flex items-center gap-2 text-xs text-gray-600">
//     <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: color }} />
//     <span className="truncate">{label}</span>
//     <span className="ml-auto font-semibold text-gray-800">{value}</span>
//   </div>
// );

// export default function HRMDashboard() {
//   const dispatch = useDispatch();

//   const employeeState = useSelector((s) => s.employee);
//   const gradeState = useSelector((s) => s.grade);
//   const shiftState = useSelector((s) => s.shift);
//   const bankState = useSelector((s) => s.bank);
//   const branchState = useSelector((s) => s.branch);
//   const categoryState = useSelector((s) => s.employeeCategory);

//   useEffect(() => {
//     dispatch(getEmployeeList()).catch(() => {});
//     dispatch(getGradeList()).catch(() => {});
//     dispatch(getShiftList()).catch(() => {});
//     dispatch(getBankList()).catch(() => {});
//     dispatch(getBranchList()).catch(() => {});
//     dispatch(getEmployeeCategoryList()).catch(() => {});
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   /* Real attendance for the current month — the same feed and the same maths
//      the main dashboard uses, so both pages report one number. Kept in local
//      state rather than redux because nothing else on this page needs the rows. */
//   const [attendanceRows, setAttendanceRows] = useState([]);
//   const [attendanceReloadKey, setAttendanceReloadKey] = useState(0);

//   useEffect(() => {
//     let cancelled = false;
//     const { fromDate, toDate } = monthBounds(new Date());
//     getEmployeesAttendanceRows({ fromDate, toDate })
//       .then((rows) => { if (!cancelled) setAttendanceRows(Array.isArray(rows) ? rows : []); })
//       .catch((err) => {
//         console.error("[eHRM Overview] attendance failed:", err);
//         if (!cancelled) setAttendanceRows([]);
//       });
//     return () => { cancelled = true; };
//   }, [attendanceReloadKey]);

//   const lookups = useMemo(
//     () =>
//       buildLookups({
//         grades: gradeState.list,
//         shifts: shiftState.list,
//         categories: categoryState.list,
//         banks: bankState.list,
//       }),
//     [gradeState.list, shiftState.list, categoryState.list, bankState.list]
//   );

//   const codeMaps = useMemo(() => ({ gender: toCodeMap(GENDERS) }), []);

//   const employees = useMemo(
//     () =>
//       (employeeState.list || []).map((row) => {
//         const mapped = mapEmployeeRow(row, lookups, codeMaps);
//         return { ...mapped, age: calcAge(mapped.dob) };
//       }),
//     [employeeState.list, lookups, codeMaps]
//   );

//   const loading = employeeState.loading;

//   // ── KPI figures ──────────────────────────────────────────────────────
//   const total = employees.length;
//   const activeCount = employees.filter((e) => e.status === "Active").length;
//   const activePct = total ? Math.round((activeCount / total) * 100) : 0;
//   const attendance = useMemo(
//     () => attendanceKpis(attendanceRows, activeCount, new Date()),
//     [attendanceRows, activeCount]
//   );
//   const byBank = useMemo(
//     () => buildBranchesByBank(bankState.list, branchState.list, pick, getRowName, getRowCode),
//     [bankState.list, branchState.list]
//   );

//   // ── Chart data ───────────────────────────────────────────────────────
//   const byGrade = useMemo(() => countBy(employees, "grade").sort((a, b) => b.value - a.value), [employees]);
//   const employeesWithAge = useMemo(() => employees.filter((e) => e.age), [employees]);
//   const byAgeGroup = useMemo(() => buildAgeGroups(employeesWithAge), [employeesWithAge]);
//   const joiningByYear = useMemo(() => buildJoiningTrend(employees), [employees]);
//   const inactiveCount = employees.filter((e) => e.status === "Inactive").length;

//   const byCategory = useMemo(() => countBy(employees, "employmentCategory"), [employees]);
//   const byGender = useMemo(
//     () => [
//       { name: "Male", value: employees.filter((e) => e.gender === "Male").length },
//       { name: "Female", value: employees.filter((e) => e.gender === "Female").length },
//     ],
//     [employees]
//   );
//   const byShift = useMemo(() => countBy(employees, "shift").sort((a, b) => b.value - a.value), [employees]);

//   const byLeaveType = useMemo(() => countBy(INITIAL_LEAVE_REQUESTS, "type").sort((a, b) => b.value - a.value), []);
//   const byLeaveStatus = useMemo(() => countBy(INITIAL_LEAVE_REQUESTS, "status"), []);

//   // ── KPI cards — this page decides what to show; StatGrid decides how it looks
//   const stats = [
//     { label: "Total Employees", value: total, sub: "All staff across branches", icon: Users, tone: "primary" },
//     { label: "Active Employees", value: activeCount, sub: `${activePct}% of total`, icon: UserCheck, tone: "emerald" },
//     { label: "Attendance Today", value: attendance.presentToday, sub: activeCount ? `of ${activeCount} active staff` : "No active staff", icon: Clock, tone: "blue" },
//     { label: "Attendance Rate", value: `${attendance.attendanceRate}%`, sub: attendance.workedDays ? `Avg over ${attendance.workedDays} day${attendance.workedDays === 1 ? "" : "s"} this month` : "No attendance this month", icon: Percent, tone: "amber" },
//     { label: "Leave Requests", value: INITIAL_LEAVE_REQUESTS.length, sub: "Sample leave log", icon: CalendarDays, tone: "violet" },
//     { label: "No. of Branches", value: branchState.list.length, sub: `Across ${byBank.length} banks`, icon: Landmark, tone: "sky" },
//   ];

//   const handleRefresh = useCallback(() => {
//     setAttendanceReloadKey((k) => k + 1);
//     dispatch(getEmployeeList()).catch(() => {});
//     dispatch(getGradeList()).catch(() => {});
//     dispatch(getShiftList()).catch(() => {});
//     dispatch(getBankList()).catch(() => {});
//     dispatch(getBranchList()).catch(() => {});
//     dispatch(getEmployeeCategoryList()).catch(() => {});
//   }, [dispatch]);

//   if (loading && !employees.length) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="flex flex-col items-center gap-3 text-gray-400">
//           <div className="w-10 h-10 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" />
//           <span className="text-sm">Loading employee data...</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="p-6 space-y-6">
//       {/* Header */}
//       {/* <div className="flex items-center justify-between">
//         <div>
//           <h1 className="text-xl font-bold text-gray-900 flex items-center gap-2">
//             <Users size={22} className="text-primary-600" /> eHRM Overview
//           </h1>
//           <p className="text-sm text-gray-500 mt-0.5">Human Resource Management Dashboard</p>
//         </div>
//         <button
//           onClick={handleRefresh}
//           disabled={loading}
//           className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition-colors disabled:opacity-50"
//         >
//           <RefreshCw size={14} className={loading ? "animate-spin" : ""} /> Refresh
//         </button>
//       </div> */}

//       {!total ? (
//         <div className="text-center py-16 text-gray-400">
//           <Users size={48} className="mx-auto mb-3 opacity-30" />
//           <p>No employee data available</p>
//         </div>
//       ) : (
//         <>
//           {/* ── KPI row ──────────────────────────────────────────────── */}
//           <StatGrid stats={stats} columns={6} />

//           {/* ── Row 2: Grade / Age / Joining trend ─────────────────────── */}
//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//             <ChartCard title="Employee Count by Grade" icon={BarChart3}>
//               <ResponsiveContainer width="100%" height={240}>
//                 <BarChart data={byGrade} margin={{ top: 8, right: 8, left: -16 }}>
//                   <CartesianGrid strokeDasharray="3 3" vertical={false} />
//                   <XAxis dataKey="name" tick={{ fontSize: 11 }} />
//                   <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
//                   <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }} />
//                   <Bar dataKey="value" name="Employees" fill="#059669" radius={[6, 6, 0, 0]} barSize={28} />
//                 </BarChart>
//               </ResponsiveContainer>
//             </ChartCard>

//             <ChartCard title="Age Group Analysis" icon={Users2}>
//               <ResponsiveContainer width="100%" height={240}>
//                 <BarChart data={byAgeGroup} margin={{ top: 8, right: 8, left: -16 }}>
//                   <CartesianGrid strokeDasharray="3 3" vertical={false} />
//                   <XAxis dataKey="name" tick={{ fontSize: 11 }} />
//                   <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
//                   <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }} />
//                   <Bar dataKey="value" name="Employees" fill="#3b82f6" radius={[6, 6, 0, 0]} barSize={32} />
//                 </BarChart>
//               </ResponsiveContainer>
//             </ChartCard>

//             <ChartCard title="Employee Joining Trend" icon={TrendingUp}>
//               <ResponsiveContainer width="100%" height={240}>
//                 <LineChart data={joiningByYear} margin={{ top: 8, right: 8, left: -16 }}>
//                   <CartesianGrid strokeDasharray="3 3" vertical={false} />
//                   <XAxis dataKey="name" tick={{ fontSize: 11 }} />
//                   <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
//                   <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }} />
//                   <Line type="monotone" dataKey="Joined" stroke="#059669" strokeWidth={2.5} dot={{ r: 3 }} />
//                 </LineChart>
//               </ResponsiveContainer>
//               <p className="text-[11px] text-gray-400 mt-1">
//                 {inactiveCount} employee{inactiveCount === 1 ? "" : "s"} currently marked Inactive — no exit-date
//                 field exists in GetEmployees, so a Resigned trend can't be computed yet.
//               </p>
//             </ChartCard>
//           </div>

//           {/* ── Row 3: Category / Gender / Leave type / Leave status / Shift / Bank ── */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//             <ChartCard title="Employee Category" icon={PieChartIcon}>
//               <ResponsiveContainer width="100%" height={170}>
//                 <PieChart>
//                   <Pie data={byCategory} dataKey="value" nameKey="name" innerRadius={45} outerRadius={70}>
//                     {byCategory.map((_, i) => (
//                       <Cell key={i} fill={PALETTE[i % PALETTE.length]} />
//                     ))}
//                   </Pie>
//                   <Tooltip />
//                 </PieChart>
//               </ResponsiveContainer>
//               <div className="grid grid-cols-2 gap-2 mt-3">
//                 {byCategory.map((c, i) => (
//                   <LegendRow
//                     key={c.name}
//                     color={PALETTE[i % PALETTE.length]}
//                     label={c.name}
//                     value={total ? `${Math.round((c.value / total) * 100)}%` : "0%"}
//                   />
//                 ))}
//               </div>
//             </ChartCard>

//             <ChartCard title="Gender Split" icon={Users}>
//               <ResponsiveContainer width="100%" height={170}>
//                 <PieChart>
//                   <Pie data={byGender} dataKey="value" nameKey="name" innerRadius={45} outerRadius={70}>
//                     <Cell fill="#3b82f6" />
//                     <Cell fill="#ec4899" />
//                   </Pie>
//                   <Tooltip />
//                 </PieChart>
//               </ResponsiveContainer>
//               <div className="grid grid-cols-2 gap-2 mt-3">
//                 <LegendRow color="#3b82f6" label="Male" value={byGender[0]?.value ?? 0} />
//                 <LegendRow color="#ec4899" label="Female" value={byGender[1]?.value ?? 0} />
//               </div>
//             </ChartCard>

//             <ChartCard title="Leave Requests by Type" icon={CalendarX}>
//               <ResponsiveContainer width="100%" height={220}>
//                 <BarChart data={byLeaveType} layout="vertical" margin={{ left: 24, right: 16 }}>
//                   <CartesianGrid strokeDasharray="3 3" horizontal={false} />
//                   <XAxis type="number" allowDecimals={false} tick={{ fontSize: 11 }} />
//                   <YAxis type="category" dataKey="name" width={110} tick={{ fontSize: 11 }} />
//                   <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }} />
//                   <Bar dataKey="value" fill="#f59e0b" radius={[0, 6, 6, 0]} barSize={16} />
//                 </BarChart>
//               </ResponsiveContainer>
//             </ChartCard>

//             <ChartCard title="Leave Requests by Status" icon={CalendarCheck2}>
//               <ResponsiveContainer width="100%" height={170}>
//                 <PieChart>
//                   <Pie data={byLeaveStatus} dataKey="value" nameKey="name" innerRadius={45} outerRadius={70}>
//                     {byLeaveStatus.map((entry, i) => (
//                       <Cell key={i} fill={STATUS_COLORS[entry.name] || PALETTE[i % PALETTE.length]} />
//                     ))}
//                   </Pie>
//                   <Tooltip />
//                 </PieChart>
//               </ResponsiveContainer>
//               <div className="grid grid-cols-1 gap-2 mt-3">
//                 {byLeaveStatus.map((s) => {
//                   const leaveTotal = INITIAL_LEAVE_REQUESTS.length;
//                   const pct = leaveTotal ? Math.round((s.value / leaveTotal) * 100) : 0;
//                   return (
//                     <LegendRow
//                       key={s.name}
//                       color={STATUS_COLORS[s.name] || "#94a3b8"}
//                       label={s.name}
//                       value={`${s.value} (${pct}%)`}
//                     />
//                   );
//                 })}
//               </div>
//             </ChartCard>

//             <ChartCard title="Employees by Shift" icon={Watch}>
//               <ResponsiveContainer width="100%" height={220}>
//                 <BarChart data={byShift} margin={{ top: 8, right: 8, left: -16 }}>
//                   <CartesianGrid strokeDasharray="3 3" vertical={false} />
//                   <XAxis dataKey="name" tick={{ fontSize: 11 }} />
//                   <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
//                   <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }} />
//                   <Bar dataKey="value" fill="#8b5cf6" radius={[6, 6, 0, 0]} barSize={28} />
//                 </BarChart>
//               </ResponsiveContainer>
//             </ChartCard>

//             <ChartCard title="No. of Branches by Bank" icon={Landmark}>
//               {byBank.length ? (
//                 <ResponsiveContainer width="100%" height={220}>
//                   <BarChart data={byBank} margin={{ top: 8, right: 8, left: -16 }}>
//                     <CartesianGrid strokeDasharray="3 3" vertical={false} />
//                     <XAxis dataKey="name" tick={{ fontSize: 10 }} interval={0} angle={-20} textAnchor="end" height={45} />
//                     <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
//                     <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }} />
//                     <Bar dataKey="value" name="Branches" fill="#0ea5e9" radius={[6, 6, 0, 0]} barSize={28} />
//                   </BarChart>
//                 </ResponsiveContainer>
//               ) : (
//                 <p className="text-gray-400 text-sm text-center py-10">No branch data available</p>
//               )}
//             </ChartCard>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Users,
  UserCheck,
  Clock,
  Percent,
  CalendarDays,
  Landmark,
  BarChart3,
  Users2,
  TrendingUp,
  PieChart as PieChartIcon,
  Watch,
  CalendarX,
  CalendarCheck2,
  RefreshCw,
} from "lucide-react";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import { fetchAllEmployees } from "../../store/slices/employeeSlice";
import { getGradeList } from "../../store/slices/gradeSlice";
import { getShiftList } from "../../store/slices/shiftSlice";
import { getBankList } from "../../store/slices/bankSlice";
import { getBankBranchList } from "../../store/slices/bankBranchSlice";
import { getEmployeeCategoryList } from "../../store/slices/employeeCategorySlice";

import { mapEmployeeRow, buildLookups } from "../../utils/employeeMapper";
import { pick, getRowName, getRowCode, toCodeMap } from "../../utils/masterDataUtils";
import {
  countBy,
  calcAge,
  buildAgeGroups,
  buildJoiningTrend,
  buildBranchesByBank,
} from "../../utils/eHrmDashboardAnalytics";
import { attendanceKpis, monthBounds, LEAVE_STATUSES, leaveTypeMap } from "../../utils/mainDashboardAnalytics";
import leaveService from "../../services/LeaveService";
import { getEmployeesAttendanceRows } from "../../store/slices/attendanceSummarySlice";

import { StatGrid, ChartCard } from "../../components/dashboard";
const GENDERS = [
  { value: "M", label: "Male" },
  { value: "F", label: "Female" },
];

const PALETTE = ["#059669", "#3b82f6", "#f59e0b", "#ef4444", "#8b5cf6", "#ec4899", "#14b8a6", "#f97316"];
const STATUS_COLORS = { Approved: "#059669", Pending: "#f59e0b", Rejected: "#ef4444", Cancelled: "#94a3b8" };

/* ResultSet out of an API response, whatever shape it comes back in. */
const rowsOf = (res) => {
  if (!res) return [];
  if (Array.isArray(res)) return res;
  const body = res.data !== undefined && res.data !== null ? res.data : res;
  const set = body.ResultSet ?? body.Result ?? body.Data ?? null;
  if (Array.isArray(set)) return set;
  return set ? [set] : [];
};


const LegendRow = ({ color, label, value }) => (
  <div className="flex items-center gap-2 text-xs text-gray-600">
    <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: color }} />
    <span className="truncate">{label}</span>
    <span className="ml-auto font-semibold text-gray-800">{value}</span>
  </div>
);

export default function HRMDashboard() {
  const dispatch = useDispatch();

  /* All six lists come from store/slices. Each slice names its own collection
     (employees / grades / shifts …) rather than the classic `list`, so they are
     read out once here and the rest of the page keeps using plain arrays. */
  const employeeState = useSelector((s) => s.employees);
  const employeeRows = employeeState.employees;
  const gradeRows = useSelector((s) => s.gradeSlice.grades);
  const shiftRows = useSelector((s) => s.shiftSlice.shifts);
  const bankRows = useSelector((s) => s.bankSlice.banks);
  const branchRows = useSelector((s) => s.bankBranchSlice.bankBranches);
  const categoryRows = useSelector((s) => s.employeeCategorySlice.categories);

  useEffect(() => {
    dispatch(fetchAllEmployees());
    dispatch(getGradeList());
    dispatch(getShiftList());
    dispatch(getBankList());
    dispatch(getBankBranchList());
    dispatch(getEmployeeCategoryList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const [attendanceRows, setAttendanceRows] = useState([]);
  const [attendanceReloadKey, setAttendanceReloadKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const { fromDate, toDate } = monthBounds(new Date());
    getEmployeesAttendanceRows({ fromDate, toDate })
      .then((rows) => { if (!cancelled) setAttendanceRows(Array.isArray(rows) ? rows : []); })
      .catch((err) => {
        console.error("[eHRM Overview] attendance failed:", err);
        if (!cancelled) setAttendanceRows([]);
      });
    return () => { cancelled = true; };
  }, [attendanceReloadKey]);

  const lookups = useMemo(
    () =>
      buildLookups({
        grades: gradeRows,
        shifts: shiftRows,
        categories: categoryRows,
        banks: bankRows,
      }),
    [gradeRows, shiftRows, categoryRows, bankRows]
  );

  const codeMaps = useMemo(() => ({ gender: toCodeMap(GENDERS) }), []);

  /* The classic action de-duplicated the API rows before storing them; the
     slice keeps what the endpoint returns, so the de-dupe happens here rather
     than counting one employee twice in every chart. */
  const employees = useMemo(() => {
    const seen = new Set();
    return (employeeRows || [])
      .filter((row) => {
        const id = String(row.HED_EMPLOYEE_ID ?? row.HED_SERVICE_NO ?? "");
        if (!id) return true;
        if (seen.has(id)) return false;
        seen.add(id);
        return true;
      })
      .map((row) => {
        const mapped = mapEmployeeRow(row, lookups, codeMaps);
        return { ...mapped, age: calcAge(mapped.dob) };
      });
  }, [employeeRows, lookups, codeMaps]);

  const loading = employeeState.loading;

  // ── KPI figures ──────────────────────────────────────────────────────
  const total = employees.length;
  const activeCount = employees.filter((e) => e.status === "Active").length;
  const activePct = total ? Math.round((activeCount / total) * 100) : 0;
  const attendance = useMemo(
    () => attendanceKpis(attendanceRows, activeCount, new Date()),
    [attendanceRows, activeCount]
  );
  const byBank = useMemo(
    () => buildBranchesByBank(bankRows, branchRows, pick, getRowName, getRowCode),
    [bankRows, branchRows]
  );

  // ── Chart data ───────────────────────────────────────────────────────
  const byGrade = useMemo(() => countBy(employees, "grade").sort((a, b) => b.value - a.value), [employees]);
  const employeesWithAge = useMemo(() => employees.filter((e) => e.age), [employees]);
  const byAgeGroup = useMemo(() => buildAgeGroups(employeesWithAge), [employeesWithAge]);
  const joiningByYear = useMemo(() => buildJoiningTrend(employees), [employees]);
  const inactiveCount = employees.filter((e) => e.status === "Inactive").length;

  const byCategory = useMemo(() => countBy(employees, "employmentCategory"), [employees]);
  const byGender = useMemo(
    () => [
      { name: "Male", value: employees.filter((e) => e.gender === "Male").length },
      { name: "Female", value: employees.filter((e) => e.gender === "Female").length },
    ],
    [employees]
  );
  const byShift = useMemo(() => countBy(employees, "shift").sort((a, b) => b.value - a.value), [employees]);

  /* Leave requests — real data, the same calls the main Dashboard makes. A
     status that fails to load just counts as empty. */
  const [leaveRows, setLeaveRows] = useState([]);
  const [leaveLoading, setLeaveLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    (async () => {
      setLeaveLoading(true);
      const [typesRes, ...statusRes] = await Promise.allSettled([
        leaveService.GetLeaveTypeList(),
        ...LEAVE_STATUSES.map((st) => leaveService.GetLeavesRequestByStatus(st)),
      ]);
      if (!alive) return;
      const typeMap = leaveTypeMap(typesRes.status === "fulfilled" ? rowsOf(typesRes.value) : []);
      const rows = [];
      LEAVE_STATUSES.forEach((st, i) => {
        const res = statusRes[i];
        const list = res.status === "fulfilled" ? rowsOf(res.value) : [];
        const label = st.charAt(0) + st.slice(1).toLowerCase();
        list.forEach((r) => rows.push({
          status: label,
          type: typeMap[String(r.HLF_LEAVE_TYPE_ID ?? "").trim()] || "Unassigned",
        }));
      });
      setLeaveRows(rows);
      setLeaveLoading(false);
    })();
    return () => { alive = false; };
  }, []);

  const byLeaveType = useMemo(() => countBy(leaveRows, "type").sort((a, b) => b.value - a.value), [leaveRows]);
  const byLeaveStatus = useMemo(() => countBy(leaveRows, "status"), [leaveRows]);

  // ── KPI cards — this page decides what to show; StatGrid decides how it looks
  const stats = [
    { label: "Total Employees", value: total, sub: "All staff across branches", icon: Users, tone: "primary" },
    { label: "Active Employees", value: activeCount, sub: `${activePct}% of total`, icon: UserCheck, tone: "emerald" },
    { label: "Attendance Today", value: attendance.presentToday, sub: activeCount ? `of ${activeCount} active staff` : "No active staff", icon: Clock, tone: "blue" },
    { label: "Attendance Rate", value: `${(Number(attendance.attendanceRate) || 0).toFixed(2)}%`, sub: attendance.workedDays ? `Avg over ${attendance.workedDays} day${attendance.workedDays === 1 ? "" : "s"} this month` : "No attendance this month", icon: Percent, tone: "amber" },
    { label: "Leave Requests", value: leaveLoading ? "…" : leaveRows.length, sub: "All leave requests", icon: CalendarDays, tone: "violet" },
    { label: "No. of Branches", value: branchRows.length, sub: `Across ${byBank.length} banks`, icon: Landmark, tone: "sky" },
  ];

  const handleRefresh = useCallback(() => {
    setAttendanceReloadKey((k) => k + 1);
    dispatch(fetchAllEmployees());
    dispatch(getGradeList());
    dispatch(getShiftList());
    dispatch(getBankList());
    dispatch(getBankBranchList());
    dispatch(getEmployeeCategoryList());
  }, [dispatch]);

  if (loading && !employees.length) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="flex flex-col items-center gap-3 text-gray-400">
          <div className="w-10 h-10 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" />
          <span className="text-sm">Loading employee data...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      {/* <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-gray-900 flex items-center gap-2">
            <Users size={22} className="text-primary-600" /> eHRM Overview
          </h1>
          <p className="text-sm text-gray-500 mt-0.5">Human Resource Management Dashboard</p>
        </div>
        <button
          onClick={handleRefresh}
          disabled={loading}
          className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition-colors disabled:opacity-50"
        >
          <RefreshCw size={14} className={loading ? "animate-spin" : ""} /> Refresh
        </button>
      </div> */}

      {!total ? (
        <div className="text-center py-16 text-gray-400">
          <Users size={48} className="mx-auto mb-3 opacity-30" />
          <p>No employee data available</p>
        </div>
      ) : (
        <>
          {/* ── KPI row ──────────────────────────────────────────────── */}
          <StatGrid stats={stats} columns={6} />

          {/* ── Row 2: Grade / Age / Joining trend ─────────────────────── */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <ChartCard title="Employee Count by Grade" icon={BarChart3}>
              <ResponsiveContainer width="100%" height={240}>
                <BarChart data={byGrade} margin={{ top: 8, right: 8, left: -16 }}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="name" tick={{ fontSize: 11 }} />
                  <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
                  <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }} />
                  <Bar dataKey="value" name="Employees" fill="#059669" radius={[6, 6, 0, 0]} barSize={28} />
                </BarChart>
              </ResponsiveContainer>
            </ChartCard>

            <ChartCard title="Age Group Analysis" icon={Users2}>
              <ResponsiveContainer width="100%" height={240}>
                <BarChart data={byAgeGroup} margin={{ top: 8, right: 8, left: -16 }}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="name" tick={{ fontSize: 11 }} />
                  <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
                  <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }} />
                  <Bar dataKey="value" name="Employees" fill="#3b82f6" radius={[6, 6, 0, 0]} barSize={32} />
                </BarChart>
              </ResponsiveContainer>
            </ChartCard>

            <ChartCard title="Employee Joining Trend" icon={TrendingUp}>
              <ResponsiveContainer width="100%" height={240}>
                <LineChart data={joiningByYear} margin={{ top: 8, right: 8, left: -16 }}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="name" tick={{ fontSize: 11 }} />
                  <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
                  <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }} />
                  <Line type="monotone" dataKey="Joined" stroke="#059669" strokeWidth={2.5} dot={{ r: 3 }} />
                </LineChart>
              </ResponsiveContainer>
              <p className="text-[11px] text-gray-400 mt-1">
                {inactiveCount} employee{inactiveCount === 1 ? "" : "s"} currently marked Inactive — no exit-date
                field exists in GetEmployees, so a Resigned trend can't be computed yet.
              </p>
            </ChartCard>
          </div>

          {/* ── Row 3: Category / Gender / Leave type / Leave status / Shift / Bank ── */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <ChartCard title="Employee Category" icon={PieChartIcon}>
              <ResponsiveContainer width="100%" height={170}>
                <PieChart>
                  <Pie data={byCategory} dataKey="value" nameKey="name" innerRadius={45} outerRadius={70}>
                    {byCategory.map((_, i) => (
                      <Cell key={i} fill={PALETTE[i % PALETTE.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
              <div className="grid grid-cols-2 gap-2 mt-3">
                {byCategory.map((c, i) => (
                  <LegendRow
                    key={c.name}
                    color={PALETTE[i % PALETTE.length]}
                    label={c.name}
                    value={total ? `${Math.round((c.value / total) * 100)}%` : "0%"}
                  />
                ))}
              </div>
            </ChartCard>

            <ChartCard title="Gender Split" icon={Users}>
              <ResponsiveContainer width="100%" height={170}>
                <PieChart>
                  <Pie data={byGender} dataKey="value" nameKey="name" innerRadius={45} outerRadius={70}>
                    <Cell fill="#3b82f6" />
                    <Cell fill="#ec4899" />
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
              <div className="grid grid-cols-2 gap-2 mt-3">
                <LegendRow color="#3b82f6" label="Male" value={byGender[0]?.value ?? 0} />
                <LegendRow color="#ec4899" label="Female" value={byGender[1]?.value ?? 0} />
              </div>
            </ChartCard>

            <ChartCard title="Leave Requests by Type" icon={CalendarX} empty={!leaveLoading && leaveRows.length === 0} emptyText="No leave requests">
              <ResponsiveContainer width="100%" height={220}>
                <BarChart data={byLeaveType} layout="vertical" margin={{ left: 24, right: 16 }}>
                  <CartesianGrid strokeDasharray="3 3" horizontal={false} />
                  <XAxis type="number" allowDecimals={false} tick={{ fontSize: 11 }} />
                  <YAxis type="category" dataKey="name" width={110} tick={{ fontSize: 11 }} />
                  <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }} />
                  <Bar dataKey="value" fill="#f59e0b" radius={[0, 6, 6, 0]} barSize={16} />
                </BarChart>
              </ResponsiveContainer>
            </ChartCard>

            <ChartCard title="Leave Requests by Status" icon={CalendarCheck2} empty={!leaveLoading && leaveRows.length === 0} emptyText="No leave requests">
              <ResponsiveContainer width="100%" height={170}>
                <PieChart>
                  <Pie data={byLeaveStatus} dataKey="value" nameKey="name" innerRadius={45} outerRadius={70}>
                    {byLeaveStatus.map((entry, i) => (
                      <Cell key={i} fill={STATUS_COLORS[entry.name] || PALETTE[i % PALETTE.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
              <div className="grid grid-cols-1 gap-2 mt-3">
                {byLeaveStatus.map((s) => {
                  const leaveTotal = leaveRows.length;
                  const pct = leaveTotal ? Math.round((s.value / leaveTotal) * 100) : 0;
                  return (
                    <LegendRow
                      key={s.name}
                      color={STATUS_COLORS[s.name] || "#94a3b8"}
                      label={s.name}
                      value={`${s.value} (${pct}%)`}
                    />
                  );
                })}
              </div>
            </ChartCard>

            <ChartCard title="Employees by Shift" icon={Watch}>
              <ResponsiveContainer width="100%" height={220}>
                <BarChart data={byShift} margin={{ top: 8, right: 8, left: -16 }}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="name" tick={{ fontSize: 11 }} />
                  <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
                  <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }} />
                  <Bar dataKey="value" fill="#8b5cf6" radius={[6, 6, 0, 0]} barSize={28} />
                </BarChart>
              </ResponsiveContainer>
            </ChartCard>

            <ChartCard title="No. of Branches by Bank" icon={Landmark}>
              {byBank.length ? (
                <ResponsiveContainer width="100%" height={220}>
                  <BarChart data={byBank} margin={{ top: 8, right: 8, left: -16 }}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis dataKey="name" tick={{ fontSize: 10 }} interval={0} angle={-20} textAnchor="end" height={45} />
                    <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
                    <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }} />
                    <Bar dataKey="value" name="Branches" fill="#0ea5e9" radius={[6, 6, 0, 0]} barSize={28} />
                  </BarChart>
                </ResponsiveContainer>
              ) : (
                <p className="text-gray-400 text-sm text-center py-10">No branch data available</p>
              )}
            </ChartCard>
          </div>
        </>
      )}
    </div>
  );
}